export const visit = (vm, at) => {
at({ "de": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Leider konnten wir Ihre E-Mail-Adresse nicht verifizieren." } } } });
};